module.exports = __webpack_public_path__ + "static/media/scooty-2x.6268124c.png";